import { map } from 'ramda';
import moment from 'moment';
import { NA } from 'constants/common';

export function getPersonalDetailsItemTitle(value) {
  switch (value) {
    case 'mobile':
      return 'patient.mobile';
    case 'home':
      return 'patient.landline';
    default:
      return value;
  }
}

export function getFormattedTelecom(data) {
  return map(
    ({ use, value }) => ({
      title: getPersonalDetailsItemTitle(use),
      value,
    }),
    data,
  );
}

export function getAccumulatorSeparator(acc, index) {
  if (index === 2) {
    return `${acc} `;
  }
  return index !== 0 ? `${acc}, ` : acc;
}

export function getAccumulatorSeparatorWithNA(acc, index) {
  const value = index === 0 ? acc : acc || NA;
  return getAccumulatorSeparator(value, index);
}

export const formatDate = pattern => date => (date ? moment(date).format(pattern) : NA);

export const formatDateOr = (alt, pattern) => date => (date ? moment(date).format(pattern) : alt);

export const getAgeFromDob = dob =>
  moment()
    .diff(dob, 'years')
    .toString();
export const getAgeFromDobOr = (alt, dob) => (dob ? getAgeFromDob(dob) : alt);
